import{FlexStyle as e}from"@kui-shared/flex";var t=e;import{FlexDefaults as a}from"@kui-shared/flex";var s={Stack:"kui-stack"},p={...a,direction:"column",gap:"none"};export{p as StackDefaults,t as StackStyle,s as StackTestIDs};
